/**
 * Videa na webu.
 *
 *  .js-autoplay – video v úvodu. Hraje samo bez zvuku; při
 *                 prefers-reduced-motion se zastaví a ukáže se jen poster.
 *  .js-inview   – videa v realizacích. Zdroj se stáhne až ve chvíli, kdy je
 *                 video na obrazovce (data-src → src), a hraje jen tam –
 *                 mimo obrazovku se zastaví, ať nežere data ani baterii.
 *
 * Každé video má vedle sebe tlačítko .video-toggle (WCAG 2.2.2 – pohyb
 * delší než 5 s musí jít zastavit). Když ho návštěvník použije, jeho volba
 * má přednost před automatikou.
 */
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function syncToggle(video) {
    const btn = video.parentElement.querySelector('.video-toggle');
    if (!btn) return;
    const paused = video.paused;
    // jen měnící se popisek (bez aria-pressed) – odečítač tak nečte zdvojený stav
    btn.setAttribute('aria-label', paused ? 'Přehrát video' : 'Pozastavit video');
    btn.querySelector('.material-symbols-outlined').textContent = paused ? 'play_arrow' : 'pause';
}

function loadSource(video) {
    video.querySelectorAll('source[data-src]').forEach((s) => {
        s.src = s.dataset.src;
        s.removeAttribute('data-src');
    });
    video.load();
}

function play(video) {
    if (video.dataset.poster) { video.poster = video.dataset.poster; delete video.dataset.poster; }
    if (video.querySelector('source[data-src]')) loadSource(video);
    const p = video.play();
    if (p && p.catch) p.catch(() => syncToggle(video)); // autoplay zakázaný prohlížečem
}

function bindToggle(video) {
    const btn = video.parentElement.querySelector('.video-toggle');
    video.addEventListener('play', () => syncToggle(video));
    video.addEventListener('pause', () => syncToggle(video));
    if (!btn) return;

    btn.addEventListener('click', () => {
        video.dataset.userChoice = video.paused ? 'play' : 'pause';
        video.paused ? play(video) : video.pause();
    });
}

function initAutoplay() {
    const videos = document.querySelectorAll('video.js-autoplay');
    if (!videos.length) return;

    videos.forEach((video) => {
        bindToggle(video);
        syncToggle(video);
    });

    // při „omezit pohyb" zůstane jen poster, video spustí až tlačítko
    if (reduceMotion.matches) return;

    // Video se začne stahovat až po načtení stránky (a ve volné chvíli
    // prohlížeče) – poster je LCP a nesmí se o pásmo dělit s videem.
    const start = () => videos.forEach((video) => {
        if (video.dataset.userChoice === 'pause') return;
        if (!video.getClientRects().length) return; // skryté (úvod na mobilu) – nestahovat
        play(video);
    });
    const idle = () => ('requestIdleCallback' in window ? requestIdleCallback(start, { timeout: 2000 }) : setTimeout(start, 200));

    if (document.readyState === 'complete') idle();
    else window.addEventListener('load', idle, { once: true });
}

function initInView() {
    const videos = document.querySelectorAll('video.js-inview');
    if (!videos.length) return;

    videos.forEach(bindToggle);

    // Postery (data-poster) se dotáhnou až kousek před obrazovkou – jinak by
    // se stahovaly hned s úvodem stránky a braly pásmo hlavnímu obrázku.
    const setPoster = (v) => { if (v.dataset.poster) { v.poster = v.dataset.poster; delete v.dataset.poster; } };
    if ('IntersectionObserver' in window) {
        const posterIo = new IntersectionObserver((entries, obs) => {
            entries.forEach(({ isIntersecting, target }) => {
                if (!isIntersecting) return;
                setPoster(target);
                obs.unobserve(target);
            });
        }, { rootMargin: '600px' });
        videos.forEach((v) => posterIo.observe(v));
    } else {
        videos.forEach(setPoster);
    }
    if (reduceMotion.matches || !('IntersectionObserver' in window)) return;

    // Na mobilu (a při úsporném režimu dat) se videa v obsahu sama nestahují:
    // je vidět poster s tlačítkem ▶ a video (jednotky MB) se stáhne až na
    // klepnutí. Jinak by dekódování videa v úvodu detailu realizace blokovalo
    // stránku stovky milisekund a PageSpeed by na mobilu padal pod 90.
    const lowData = window.matchMedia('(max-width: 820px)').matches || navigator.connection?.saveData;
    if (lowData) return;

    // Na desktopu se videa rozjedou samy, ale až po načtení stránky – hlavní
    // obsah a fotky mají přednost (stejně jako video v úvodu homepage).
    const start = () => {
        const io = new IntersectionObserver((entries) => {
            entries.forEach(({ target: video, isIntersecting }) => {
                if (video.dataset.userChoice === 'pause') return;
                isIntersecting ? play(video) : video.pause();
            });
        }, { threshold: 0.6 });
        videos.forEach((v) => io.observe(v));
    };
    const idle = () => ('requestIdleCallback' in window ? requestIdleCallback(start, { timeout: 2000 }) : setTimeout(start, 200));
    if (document.readyState === 'complete') idle();
    else window.addEventListener('load', idle, { once: true });
}

initAutoplay();
initInView();
